import { render, staticRenderFns } from "./OrgUsers.vue?vue&type=template&id=bc3f8d7a&scoped=true"
import script from "./OrgUsers.vue?vue&type=script&lang=js"
export * from "./OrgUsers.vue?vue&type=script&lang=js"
import style0 from "./OrgUsers.vue?vue&type=style&index=0&id=bc3f8d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3f8d7a",
  null
  
)

export default component.exports